(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["header-actions"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', (event) => {
      if (event.target.closest('.action__cart')) {
        event.preventDefault();
      }
    });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["houseware-progress"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('houseware-scroll-progress')) {
    customElements.define('houseware-scroll-progress', class extends HTMLElement {
      connectedCallback() {
        this.scroller = this.querySelector('[data-scroller]');
        this.track = this.querySelector('[data-progress-track]');
        this.fill = this.querySelector('[data-progress-fill]');
        if (!this.scroller || !this.track || !this.fill) return;
        this.update = this.update.bind(this);
        this.scroller.addEventListener('scroll', this.update, { passive: true });
        this.ro = new ResizeObserver(this.update);
        this.ro.observe(this.scroller);
        this.update();
      }
      disconnectedCallback() { if (this.ro) this.ro.disconnect(); }
      update() {
        const s = this.scroller, max = s.scrollWidth - s.clientWidth;
        if (max <= 1) { this.track.style.visibility = 'hidden'; return; }
        this.track.style.visibility = '';
        const travel = this.track.clientWidth - this.fill.offsetWidth;
        this.fill.style.transform = 'translateX(' + (s.scrollLeft / max * travel) + 'px)';
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
